import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, withRouter, NavLink } from 'react-router-dom';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';

import DashboardContainer from './dashboard/DashboardContainer';
import ApplicationContainer from './application/container/ApplicationContainer';

import MiscellaneousFeeSettings from './settings/MiscellaneousFeeSettings';
import MiscellaneousFeeReports from './reports/MiscellaneousFeeReports'

const MiscellaneousFeeContainer = ({ match }) => {
  const permissions = getJson('permissions');
  return (
    <div className="module-inner">
      <div className="module-inner-title">Miscellaneous Fees</div>
      <div className="generic-module-nav mb-3">
        {Acl(permissions, ['VIEW MISCELLANEOUS FEES DASHBOARD']) && (
          <NavLink
            exact
            className="nav-link"
            activeClassName="active"
            to="/miscellaneous-fees"
          >
            Dashboard
          </NavLink>
        )}
        {Acl(permissions, ['VIEW MISCELLANEOUS FEES TRANSACTIONS']) && (
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/miscellaneous-fees/application"
          >
            Applications
          </NavLink>
        )}
        {Acl(permissions, ['VIEW MISCELLANEOUS FEES SETTINGS']) && (
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/miscellaneous-fees/settings"
          >
            Settings
          </NavLink>
        )}
        {Acl(permissions, ['VIEW MISCELLANEOUS FEES REPORTS']) && (
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/miscellaneous-fees/reports"
          >
            Reports
          </NavLink>
        )}
      </div>
      <Switch>
        {Acl(permissions, ['VIEW MISCELLANEOUS FEES DASHBOARD']) && (
          <Route exact path={`${match.path}`} component={DashboardContainer} />
        )}
        {Acl(permissions, ['VIEW MISCELLANEOUS FEES TRANSACTIONS']) && (
          <Route
            path={`${match.path}/application`}
            component={ApplicationContainer}
          />
        )}
        {Acl(permissions, ['VIEW MISCELLANEOUS FEES SETTINGS']) && (
          <Route
            path={`${match.path}/settings`}
            component={MiscellaneousFeeSettings}
          />
        )}
        {Acl(permissions, ['VIEW MISCELLANEOUS FEES REPORTS']) && (
          <Route
            path={`${match.path}/reports`}
            component={MiscellaneousFeeReports}
          />
        )}
      </Switch>
    </div>
  );
};

MiscellaneousFeeContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

export default withRouter(MiscellaneousFeeContainer);
